import { Component } from '@theme/component';

/**
 * Motor-Karten der Gazelle-LP (sections/ebo-gaz-motoren.liquid).
 *
 * Die Links „Alle Modelle mit diesem Antrieb" sind serverseitig gerenderte
 * Facetten-URLs (Motor-Typ-Filter aus den Block-Settings). Ohne JS
 * navigieren sie ganz normal (Fallback inkl. #ResultsList-Anker auf die
 * Produktliste). Mit JS werden Klicks in den nativen Facets-Flow des
 * Themes umgeleitet: facets-form-component.updateFiltersByURL() pusht die
 * URL und morpht die Produktliste per Section-Rendering-API — dasselbe
 * Muster wie die Schnellfilter-Chips (ebo-gaz-chips-component in
 * assets/ebo-gaz-chips.js, PR #293) und die aktiven Filter-Pills
 * (facet-remove-component in assets/facets.js), ohne Seiten-Reload.
 *
 * Anders als bei den Chips (die direkt über der Produktliste sitzen) wird
 * hier zusätzlich zur Ergebnisliste gescrollt: Die Motor-Karten stehen
 * weit oberhalb der Produktliste — ohne Scroll bliebe das Filterergebnis
 * außerhalb des Viewports und der Klick wirkte folgenlos.
 *
 * Kein Re-Render bei collection:update nötig: Die Karten-URLs kommen aus
 * statischen Block-Settings, nicht aus collection.filters — sie haben
 * keinen filterabhängigen Zustand.
 *
 * @extends {Component}
 */
class EboGazMotorenComponent extends Component {
  /**
   * Wendet die Motor-Typ-Filter-URL einer Karte ohne Seiten-Reload an (on:click).
   * @param {MouseEvent} event - Das Klick-Event
   */
  filterAnwenden(event) {
    // Neuer Tab / neues Fenster (Modifier- oder Nicht-Primärklick) dem Browser überlassen
    if (event.defaultPrevented || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    if (event instanceof MouseEvent && event.button !== 0) return;

    const link = event.target instanceof Element ? event.target.closest('a[href]') : null;
    if (!link) return;

    const facetsForm = document.querySelector('facets-form-component');
    // Upgrade-Race schließen: Element kann im DOM sein, bevor facets.js
    // dessen Klasse registriert hat (vgl. registerEventListeners in component.js)
    if (facetsForm instanceof HTMLElement) customElements.upgrade(facetsForm);

    // Kein natives Facets-Formular (Filterleiste entfernt oder facets.js noch
    // nicht geladen): normale Navigation als Fallback zulassen
    const updateFiltersByURL = /** @type {any} */ (facetsForm)?.updateFiltersByURL;
    if (typeof updateFiltersByURL !== 'function') return;

    event.preventDefault();

    // #ResultsList-Anker (No-JS-Fallback) nicht in die History übernehmen
    const url = new URL(link.href, window.location.origin);
    updateFiltersByURL.call(facetsForm, url.pathname + url.search);

    // Gefilterte Produktliste in den Blick bringen (statt Sprung nach oben
    // durch den früheren Voll-Reload). Der Morph aktualisiert die Liste in
    // place, die Scroll-Position auf #ResultsList bleibt dabei stabil.
    const ergebnisliste = document.getElementById('ResultsList');
    if (ergebnisliste) {
      const reduzierteBewegung = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      ergebnisliste.scrollIntoView({ behavior: reduzierteBewegung ? 'auto' : 'smooth', block: 'start' });
    }
  }
}

if (!customElements.get('ebo-gaz-motoren-component')) {
  customElements.define('ebo-gaz-motoren-component', EboGazMotorenComponent);
}
